import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center justify-center gap-3">
    {[1, 2, 3].map(i => (
      <div key={i} className="flex flex-col items-center gap-1">
        <div className="w-5 h-5 bg-primary/30 rounded-full flex items-center justify-center text-[8px] text-primary font-bold">{i}</div>
        <div className="w-5 h-1 bg-zinc-200 dark:bg-zinc-700 rounded" />
      </div>
    ))}
  </div>
);

export default Thumbnail;
